module.exports = __webpack_public_path__ + "static/img/200222_1138.1ab27ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/200222_1138.jpg
// module id = 2t/c
// module chunks = 1